import EventBus from '@/event-bus'
import { computed, ref } from 'vue'
import { useStore } from 'vuex'
import { useI18n } from 'vue-i18n'

const ongoingRequestsCount = ref(0)
const isRefreshing = computed(() => ongoingRequestsCount.value > 0)

export function useDataRefresh (refreshFn) {
    const store = useStore()
    const { t } = useI18n()

    if (refreshFn) {
        const onRefresh = async () => {
            ongoingRequestsCount.value++
            await refreshFn()
            ongoingRequestsCount.value--

            if (!isRefreshing.value) {
                await store.dispatch(
                    'messages/push',
                    t('communicates.data-refreshed')
                )
                EventBus.$emit('data-refreshed')
            }
        }

        EventBus.$on('data-refresh', onRefresh)
    }

    return {
        isRefreshing
    }
}
